import React from "react";
import ReactDOM from "react-dom";

if (window.__INITIAL_STATE_autosuggest_search_bar__) {
  const { brand, isSFLVeryIEHeaderEnabled } =
    window.__INITIAL_STATE_autosuggest_search_bar__;
  (async () => {
    const { default: App } = await import("./App");
    ReactDOM.hydrate(
      <App
        brand={brand as "default" | "littlewoods" | "very" | "veryireland"}
        isSFLVeryIEHeaderEnabled={isSFLVeryIEHeaderEnabled as boolean}
      />,
      document.getElementById("search-bar-root"),
    );
  })();
}
